var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgKitchen = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.1665 17.5H15.8332",
    stroke: "#929292",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0002 14.1668H5.00018V11.6668C0.833547 11.6668 0.416825 4.5835 6.25018 4.5835C6.25016 0.833513 13.7502 0.833496 13.7502 4.5835C19.5835 4.5835 19.1669 11.6668 15.0002 11.6668V14.1668Z",
    stroke: "#929292",
    strokeWidth: 1.5
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgKitchen, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Kitchen.037e274b.svg";
export { ForwardRef as ReactComponent };